<template>
    <!-- 组件主盒子 -->
    <div class="stbox">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>报警信息列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.imei" placeholder="输入IMEI"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.user" placeholder="输入用户"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.alarmInfo" placeholder="输入报警信息"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <!-- 统计图 -->
        <el-row :gutter="23" style="background-color: #F5F5F5">
            <el-col :span="15" class="text-c">
                <div class="paybox">
                    <div class="cavasbox" ref="chartDom"></div>
                </div>
            </el-col>
            <el-col :span="9" class="text-c">
                <div class="paybox">
                    <div class="cavasbox" ref="chartPie"></div>
                </div>
            </el-col>
        </el-row>

        <div style="height:10px;"></div>
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column sortable prop="id" label="ID" show-overflow-tooltip></el-table-column>
            <el-table-column prop="nickname" label="所属用户" show-overflow-tooltip></el-table-column>
            <el-table-column prop="group_name" label="分组" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dname" label="设备名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="imei" label="IMEI" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alarm_content" label="报警信息" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alarm_time" label="报警时间" show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div style="height:10px;"></div>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <div style="height:20px;"></div>
    </div>
</template>
<script type="text/ecmascript-6">
    import Chart from 'echarts'
    import Pagination from '../../components/Pagination'
    import {alarm, getPie} from "../../api/userMG";

    export default {
        name: "welcome",
        data() {
            return {
                formInline: {
                    page: 1,
                    pageSize: 10,
                    limit: 10,
                    imei: '',
                    alarmInfo: '',
                    user: ''
                },
                bar: {
                    columns: {},
                    values: {}
                },
                pie: [],
                listData: [], //用户数据
                loading: false,
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 导入组件
        components: {
            Pagination
        },
        // 创建完毕状态(里面是操作)
        created() {
        },
        // 挂载结束状态(里面是操作)
        mounted() {
            this.getPieData(this.formInline)
            this.getdata(this.formInline)
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        // 里面的函数只有调用才会执行
        methods: {
            search() {
                this.getPieData(this.formInline)
                this.getdata(this.formInline)
            },
            getdata(parameter) {
                this.loading = true
                alarm(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.pageInfo.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            getPieData() {
                getPie().then(res => {
                    if (res.code == 200) {
                        this.pie = []
                        this.bar.columns = res.data.pie_columns
                        this.bar.values = res.data.pie_values

                        this.bar.columns.forEach((item, index) => {
                            this.pie.push({value: this.bar.values[index], name: item})
                        })
                        this.initChart();
                        this.initPie();
                    }
                })
            },
            initChart() {
                this.chart = Chart.init(this.$refs.chartDom)
                var option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        // 控制图表的位置
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true,
                    },
                    xAxis: {
                        axisLabel: {
                            // X轴线 标签修改
                            textStyle: {
                                color: "#000000", //坐标值得具体的颜色
                                fontSize: "12",
                            },
                        },
                        data: this.bar.columns,
                    },
                    yAxis: {
                        axisLabel: {
                            // y轴线 标签修改
                            textStyle: {
                                color: "#000000", //坐标值得具体的颜色
                            },
                        },
                    },
                    series: [
                        {
                            name: '次数',
                            type: "bar",
                            barWidth: "40px", //调整柱状图宽度
                            itemStyle: {
                                normal: {
                                    //这里是颜色
                                    color: function (params) {
                                        //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                                        var colorList = ['#00A3E0'];
                                        return colorList[params.dataIndex]
                                    }
                                }
                            },
                            data: this.bar.values,
                        },
                    ],
                }
                this.chart.setOption(option)
            },
            initPie() {
                this.chart = Chart.init(this.$refs.chartPie)
                var option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        data: [
                            '水位报警',
                            '更换机油',
                            '温度控制',
                            '湿度保护',
                            '过流保护',
                            '缺相',
                            '过压',
                            '失压',
                            '超转速',
                            '变频器通讯故障',
                            '变频器过载',
                            '变频器过热',
                            '母线欠压',
                            '控制回路欠压',
                            '充电回路欠压',
                            '接地或短路',
                        ]
                    },
                    series: [
                        {
                            name: '报警统计',
                            type: 'pie',
                            selectedMode: 'single',
                            center: ['55%', '65%'],
                            radius: [0, '50%'],
                            label: {
                                position: 'outer',
                                fontSize: 12
                            },
                            labelLine: {
                                show: true
                            },
                            data: this.pie
                        }
                    ]
                };
                this.chart.setOption(option)
            }
        }
    };
</script>
<style>
    .stbox {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    .stbgc {
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        border-radius: 5px;
        padding: 0px 16px;
    }

    .stsearch {
        text-align: center;
    }

    .text-c {
        text-align: center;
    }

    .st-gbox {
        background-color: #fff;
        margin-top: 20px;
        border-radius: 5px;
        height: 30vh;
        box-sizing: border-box;
        padding: 10px;
    }

    .cavasbox {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .paybox {
        width: 100%;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 5px;
        margin-top: 20px;
        height: 32vh;
    }
</style>


// WEBPACK FOOTER //
// src/views/alarm/alarm.vue